import React from 'react';
import { Link } from 'react-router-dom';

const AdminNavbar = () => {
    return (
        <header className="admin-navbar">
            <div className="container mx-auto">
                <nav className="navbar-menu">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default AdminNavbar;